import { getInitialState } from './state';

const mutations = {
  SET_CLEAR_SEARCHEXAMS(state) {
    Object.assign(state, getInitialState());
  },

  SET_HAVE_ALL_EXAMS_SAME_CATEGORY(state, hasSameCategory) {
    state.data.haveAllExamsSameCategory = hasSameCategory;
  },

  SET_DETAILED_EXAMS_LIST(state, exams) {
    state.data.detailedExams = exams;
  },

  SET_SELECTED_EXAMS(state, exams) {
    state.data.manuallySelectedExams = exams;
  },

  HAS_CHANGED_SERVICES(state) {
    state.data.requestedChangeServices = true;
  }
};

export default mutations;
